import * as React from "react";
import { cn } from "@/lib/utils";

export interface KbdProps extends React.HTMLAttributes<HTMLSpanElement> {
  inverted?: boolean;
}

export function Kbd({ inverted = false, className, children, ...props }: KbdProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center font-mono text-[9.5px] leading-none",
        "h-4 min-w-4 px-1 rounded-1",
        inverted
          ? "bg-white/15 text-white border border-white/20"
          : "bg-surface-1 text-ink-700 border border-line",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
